import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { useApp } from '../../contexts/App';
import { useIsAtBottom } from '../../hooks/useIsAtBottom';
import { cn } from '../../utils/cn';
import { ArrowIcon } from './icons/ArrowIcon';
import { KeepoIcon } from './icons/Keepo';
export const Footer = () => {
    const { secondary } = useTheme();
    const { contextProps } = useApp();
    const isBottom = useIsAtBottom();
    return (_jsx("div", { className: cn('section footer-signature', {
            bottom: isBottom,
        }), children: _jsxs("div", { className: "section-center", children: [_jsxs("a", { href: contextProps.hostSite, target: "_blank", rel: "noreferrer", className: "static", children: [_jsx("span", { dangerouslySetInnerHTML: {
                                __html: contextProps.footer.credits,
                            } }), _jsx(KeepoIcon, { color: secondary })] }), _jsxs("a", { href: contextProps.hostSite, target: "_blank", rel: "noreferrer", className: "float", children: [_jsx("span", { dangerouslySetInnerHTML: {
                                __html: contextProps.footer.credits,
                            } }), _jsx(ArrowIcon, { className: "avatar-icon" })] }), _jsx("div", { className: "float", children: _jsx("div", {}) })] }) }));
};
